import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { HeaderButton } from 'src/app/models/headerbtn.model';
import { BreadCrumb } from 'src/app/models/breadcrumb.model';
import { SchoolInformationview } from 'src/app/models/schoolinformationview.model';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { JsonPipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { AddExternalMediaComponent } from 'src/app/class/add-external-media/add-external-media.component';
import { QuillEditorComponent } from 'ngx-quill';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { Settings } from 'src/app/models/settings.model';
import { BillingAccountService } from 'src/app/services/BillingAccount/billing-account.service';
//import { AccountPlanConfig } from 'src/app/models/billing/BillingAccountInfo';
//import { AccountinformationComponent } from 'src/app/billing/accountinformation/accountinformation.component';
import { forEach } from 'jszip';
import { UtilService } from 'src/app/services/util.service';
import { Bank } from 'src/app/models/bank.model';
import { PaymentService } from 'src/app/services/payment.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AccountPlanConfig, FeatureGroups } from 'src/app/models/school/schooladminitem.model';

declare const $: any;

@Component({
  selector: 'app-createschool',
  templateUrl: './createschool.component.html',
  styleUrls: ['./createschool.component.css']
})
export class CreateschoolComponent implements OnInit {
  quill: any = {};
  @ViewChild('addExternalMediaComponent') addExternalMediaComponent: AddExternalMediaComponent;
  @ViewChild('mediaModal') mediaModal: ElementRef;
  @ViewChild('externalMediaModal') externalMediaModal: ElementRef;
  @ViewChild('description') contentQuillEditor: QuillEditorComponent;
  @ViewChild('logoimg') logoimg: ElementRef
  @ViewChild('logoimg2') logoimg2: ElementRef
  @ViewChild('bankIdField') bankIdField: NgSelectComponent;
  logofilelist: FileList;
  applogofilelist: FileList;

  breadcrumb: BreadCrumb[] = [{ displaytext: 'School', route: '/user/schoolhome', params: this.activatedrouter.snapshot.queryParams },
                              { displaytext: 'School Settings', route: '/user/createschool', params: this.activatedrouter.snapshot.queryParams }];
  //headerbtn : HeaderButton[];

  successMessage: string;
  errorMessage: string;
  isSubmitting: boolean;
  schoolid: any
  isPrivateSchool: boolean;
  allowRegByUsers: boolean;
  schooInfo: SchoolInformationview = new SchoolInformationview();
  schoolparam: any
  urlparam: any;
  accountPLans: AccountPlanConfig[];
  selectedAccountPlan = new AccountPlanConfig();
  banks: Bank[] = [];
  toursteps:any[]=[];
  taketour: boolean;
  hasSubdomainFeature = false;
  timezoneinfo: any;
  timeZoneInfo: any;
  rootAdmin: string;
  //selectedPlan = 0;
  //freePlanSelected = false;
  constructor(private headerinfo: ComponentheaderService, private schoolmanagerservice: SchoolmanagementService, private router: Router, private toastr: ToastrService, private activatedrouter: ActivatedRoute, private userservice: UseraccessserviceService, public settings: Settings, private billService : BillingAccountService, private util: UtilService, private paymentservice: PaymentService) {
    // this.toursteps=[

    //   {
    //     element:'#infotoggle',
    //      intro: "Click to get more information on the field",
    //      position: 'right'
    //   },]
    this.headerinfo.setHeaderDisplay('Create School', this.breadcrumb, [{ displaytext: 'Add Video from Youtube/Vimeo', callback: this.addFromYoutube.bind(this), classes: ['fab', 'fa-youtube'] }]);
  }
  ngAfterViewInit(): void {
    const mythis = this;
    this.contentQuillEditor.onEditorCreated.subscribe(() => {
      this.quill = this.contentQuillEditor.quillEditor;
      this.loadToQuill();
    });
    this.contentQuillEditor.onEditorChanged.subscribe(() => {
      this.quill = this.contentQuillEditor.quillEditor;
    });
  }
  async ngOnInit() {

    this.urlparam = this.activatedrouter.snapshot.queryParams.dat;
    this.rootAdmin = this.activatedrouter.snapshot.queryParams.rootadmin;

    let decoded;

    this.headerinfo.pageLoadingStarted(this);

    this.hasSubdomainFeature = await this.util.hasFeature(FeatureGroups.PERSONALISED_SUBDOMAIN);

    try{
      this.schoolid = (await this.schoolmanagerservice.getSchoolFromSubdomain()).id;// this.activatedrouter.snapshot.queryParams.schoolID;
      if (this.urlparam) {
        decoded = JSON.parse(window.atob(decodeURI(this.urlparam)));
        //debugger;
        console.log(`param: ${decoded}`)
        this.schoolid = decoded.school;
          let userid = decoded.user;
          let password = decoded.pword;
          this.taketour = true;

        if (userid > 0) {
          let dat: any = await this.userservice.userAuthentication(userid, password, this.rootAdmin == '1').toPromise();
          this.userservice.setAuthenticatedUserToken(dat.token);
        }
      }
      //debugger;
      if (this.schoolid && this.schoolid > 0) {
        await this.getSchoolInfo(this.schoolid)
      }
      else {
        this.schooInfo = new SchoolInformationview();
      }
      this.schoolparam = { schoolID: this.schoolid }

      this.banks = await this.paymentservice.getBanks().toPromise();

      const response:AccountPlanConfig[] = await this.billService.getAvailableSchoolPlans().toPromise();

      this.accountPLans = response;
      this.setSelectedAccountPlan();
      console.log(this.accountPLans);
      console.log(response);
    }
    finally{
      this.headerinfo.pageLoadingDone(this);
    }
    if(this.taketour)
    {
      this.headerinfo.taketour = true;
    }
  }
  private setSelectedAccountPlan() {
    this.selectedAccountPlan = this.accountPLans.find((plan) => {
      return plan.id == this.schooInfo.accountTierId;
    });
  }

  loadToQuill(){
    if(this.quill?.root && this.schooInfo?.schoolDescription){
      this.quill.root.innerHTML = this.schooInfo.schoolDescription;
    }
  }

  async getSchoolInfo(schoolid: any) {
    var data: any = await this.schoolmanagerservice.getSchoolDetails(schoolid).toPromise();
    this.schooInfo = data.schoolInfo;
    //debugger;
    this.timeZoneInfo = this.schooInfo.timeZoneName;
    if (this.schooInfo.logoImg) {
      this.logoimg.nativeElement.style.display = 'initial';
    }
    if (this.schooInfo.appLogoImg) {
      this.logoimg2.nativeElement.style.display = 'initial';
    }
    if (this.schooInfo.schoolDescription) {
      this.loadToQuill();
    }

    // if(!this.schooInfo.bankId){
    //   this.bankIdField.clearModel();
    // }

    //this.breadcrumb.splice(2, 0, { displaytext: this.schooInfo.schoolName, route: '/user/schoolhome' });
    this.headerinfo.setHeaderDisplay('School Settings', this.breadcrumb, [{ displaytext: 'Add Video from Youtube/Vimeo', callback: this.addFromYoutube.bind(this), classes: ['fab', 'fa-youtube'] }]);

  }

  async onSubmit() {


    this.schooInfo.schoolDescription = this.quill.root.innerHTML;
    //this.schooInfo.accountTierId = this.selectedPlan;
    // if(this.schooInfo.accountTierId == 0){
    //   this.toastr.error("Please select a Plan for your new School");
    //   return;
    // }
    this.schooInfo.timeZoneName = this.timeZoneInfo.nameValue;
    const longstring = this.timeZoneInfo.timeValue.toString().split(':');
    this.schooInfo.timeZone = parseInt(longstring[0].toString().trim().replace(':', '').replace('"', '').replace('+', ''));
    this.isSubmitting = true;
    let updatedschooldata: any;
    if (this.schooInfo.id == 0) {
      updatedschooldata = await this.schoolmanagerservice.createSchool(this.schooInfo).toPromise();
      this.toastr.success("School Created Successfully");
    }
    else {
      if (this.schooInfo.id > 0){
        updatedschooldata = await this.schoolmanagerservice.editSchool(this.schooInfo).toPromise();
        this.toastr.success("School Updated Successfully");
      }
    }
    if (this.logofilelist && this.logofilelist.length > 0) {
      await this.schoolmanagerservice.uploadSchoolLogo(updatedschooldata.id, this.logofilelist[0]).toPromise();
    }
    if (this.applogofilelist && this.applogofilelist.length > 0) {
      await this.schoolmanagerservice.uploadSchoolAppLogo(updatedschooldata.id, this.applogofilelist[0]).toPromise();
    }
    this.isSubmitting = false;

    const currentSubdomain = () => {
      const location = window.location.hostname;
        const splitlocation = location.split('.');
        let subdomain = "";
        if(splitlocation.length >= 2){
          subdomain = splitlocation[0];
          if(subdomain == 'www' || subdomain == 'lms' || subdomain == 'site'){
            subdomain = '';
          }
        }
        else{
            subdomain = '';
        }
        return subdomain;
    }
    //debugger;
    if(updatedschooldata.subdomain && updatedschooldata.subdomain != currentSubdomain()){
      const newurl = await this.util.getNewSubdomainUrl(updatedschooldata.subdomain, this.userservice.getCurrentUserToken());
      window.location.href = newurl;
    }
    else{
      this.router.navigate(['/user/schoolhome']).then(() =>{ location.reload()});//putting the reload back because some settings may require a user to reload before the changes show on the back because some of the school info is cached and only loaded on initialisation of the home component
      //window.location.href = '/user/schoolhome';
    }

  }
  addFromYoutube() {
    $(this.externalMediaModal.nativeElement).modal('show');
  }

  closeExternalMediaModal() {
    this.addExternalMediaComponent.clear();
    $(this.externalMediaModal.nativeElement).modal('hide');
  }

  insertMediaUrl(playerurl) {
    const range = this.quill.getSelection();
    let index = 0;

    if (range !== null) {
      index = range.index;
    } else {
      index = this.quill.root.innerHTML.length - 1;
    }

    this.quill.insertEmbed(index, 'media', playerurl);
    this.quill.root.innerHTML += "<p></p>";
  }

  externalMediaSelected() {
    const mediaurl = this.addExternalMediaComponent.iframeurl;
    if (mediaurl) {
      this.insertMediaUrl(mediaurl);
      this.addExternalMediaComponent.clear();
      $(this.externalMediaModal.nativeElement).modal('hide');
    }
  }

  handleLogoFileChange(files: FileList) {
    if (files.length > 0) {
      this.logofilelist = files;
      this.logoimg.nativeElement.src = URL.createObjectURL(files[0]);
      this.logoimg.nativeElement.style.display = 'initial';
      return;
    }

    if (this.schooInfo.logoImg) {
      this.logoimg.nativeElement.src = this.schooInfo.logoImg;
    } else {
      this.logoimg.nativeElement.style.display = 'none';
    }
  }
  handleAppLogoFileChange(files: FileList){
    if (files.length > 0) {
      const image = new Image();
      image.onload = () => {
        // const width = image.width;
        // const height = image.height;
        // if (width !== 144 && height !== 144) {
        //   this.toastr.error(`${width}x${height} Image size must be 144x144`)
        //   return;
        // }
      this.applogofilelist = files;
      this.logoimg2.nativeElement.src = URL.createObjectURL(files[0]);
      this.logoimg2.nativeElement.style.display = 'initial';
        // Do something with the image dimensions
      };
      image.src = URL.createObjectURL(files[0]);
      return;
    }

    if (this.schooInfo.logoImg) {
      this.logoimg2.nativeElement.src = this.schooInfo.logoImg;
    } else {
      this.logoimg2.nativeElement.style.display = 'none';
    }
  }
  // handleLogoImageLoaded(): boolean {
  //   const sizevalid: boolean = this.validateModuleImage();

  //   if (!sizevalid) {
  //     this.toastr.error(`The image supplied is the wrong size. Image dimensions must be ${this.settings.moduleImageWidth} x ${this.settings.moduleImageHeight}`);
  //     return false;
  //   }
  //   else {
  //     return true;
  //   }
  // }

  // validateModuleImage(): boolean {
  //   const img = this.logoimg.nativeElement;

  //   let imageWidth = img.naturalWidth;
  //   let imageHeight = img.naturalHeight;

  //   if (Math.abs(imageWidth - this.settings.moduleImageWidth) > 2 || Math.abs(imageHeight - this.settings.moduleImageHeight) > 2) {//this gives an error margin of 2px
  //     return false;
  //   }
  //   else {
  //     return true;
  //   }
  // }


  isFreePlan(planID:number){
    let isFree = false;

    this.accountPLans.forEach(function(val,index){
      if(val.id == planID && val.free){
          isFree = true;

      }
      console.log(planID,isFree)
    });

    return isFree;
  }

  onPlanSelect(planId:number){

    //this.selectedPlan = planId;
    this.schooInfo.accountTierId = planId;
    this.schooInfo.freePlanSelected = this.isFreePlan(planId);
    this.setSelectedAccountPlan();
    console.log(this.schooInfo.accountTierId);
    //let btns = document.querySelectorAll(".planSlt");

    // btns.forEach(function(val,index){

    //   console.log(planId,val.getAttribute('data-id'))

    //   val.classList.remove('imp-btn-success');
    //   val.classList.remove('imp-btn-success-disabled');

    //    if(planId ==  Number.parseInt( val.getAttribute('data-id') ) ){
    //       val.classList.add('imp-btn-success');
    //       val.setAttribute('value', 'Plan Selected');
    //    }else{
    //      val.classList.add('imp-btn-success-disabled');
    //      val.setAttribute('value', 'Select Plan');
    //    }

    //  });


  }

}
